// extracted by mini-css-extract-plugin
module.exports = {"logo":"header_logo__3W4fD","top":"header_top__31XRy","bottomContent":"header_bottomContent__2tpJY","logoWrapper":"header_logoWrapper__17Vly","bottom":"header_bottom__12vp_"};